import axiosInstance from "../../app/apiClient";
import { DataParam, configsAdminService } from "../model/config.model";


const getconfigsData = () => axiosInstance.get(`api/v1/configs`);
const addconfigs = (data: DataParam) => axiosInstance.post(`api/v1/configs`, data);
const updateconfigs = (data: DataParam) => axiosInstance.post(`api/v1/configs`, data)
const removeconfigs = (id: number) => axiosInstance.delete(`api/v1/configs/${id}`)
const getOneconfigs = (id: number) => axiosInstance.get(`api/v1/configs/${id}`)
const getDataHolydays = () => axiosInstance.get(`api/v1/holidays`)
const updateDataHolydays = (data: any) => axiosInstance.post(`api/v1/holidays`, data)
const createDataHolydays = (data: any) => axiosInstance.post(`api/v1/holidays/createHoliday`, data)
const getQRcode = (data: any) => axiosInstance.post(`/QR-code`, data)
const getDataWhiteDay = () => axiosInstance.get(`api/v1/whileList`)
const createDataWhiteDay = (data: any) => axiosInstance.post(`api/v1/whileList/createWhileList`, data)
const updateDataWhiteDay = (data: any) => axiosInstance.post(`api/v1/whileList`, data)

const configssAdmin: configsAdminService = {
    getconfigsData,
    addconfigs,
    updateconfigs,
    removeconfigs,
    getOneconfigs,
    getDataHolydays,
    updateDataHolydays,
    createDataHolydays,
    getQRcode,
    getDataWhiteDay,
    createDataWhiteDay,
    updateDataWhiteDay
}
export default configssAdmin;